export default [
  {
    prop: 'app_name',
    label: '应用名称',
    minWidth: 130,
    tooltip: true
  },
  {
    prop: 'appid',
    label: '微信APPID',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'mch',
    label: '商户号',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'main_company_name',
    label: '公司主体',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'download_url',
    label: '下载链接',
    minWidth: '150px',
    tooltip: true
  },
  {
    prop: 'app_user_agreement_url',
    label: 'APP用户协议',
    minWidth: '150px',
    tooltip: true
  },
  {
    prop: 'is_oauth',
    label: '授权登录',
    minWidth: '100px'
  },
  {
    prop: 'status',
    label: '状态',
    minWidth: '100px'
  },
  {
    prop: 'reject_msg',
    label: '拒绝原因',
    minWidth: '150px',
    tooltip: true
  },
  {
    prop: 'action',
    width: '100px',
    label: '操作'
  }
]
